@if (initialized) {
    <p-tabs [value]="activeTabIndex" (valueChange)="activeTabIndex = +$event">
        <p-tablist>
            <p-tab [value]="0">Meine Tickets</p-tab>
            <p-tab [value]="1">Meine erstellten Tickets</p-tab>
            <p-tab [value]="2">Geschlossene Tickets</p-tab>
<!--            <p-tab [value]="3">Zugewiesene geschlossene Tickets</p-tab>-->
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel [value]="0">
                @if (activeTabIndex == 0 && allTicketAssign) {
                    <mvs-widget
                                [widgetData]="allTicketAssign"
                                (onObjectSelect)="handleTicketSelect($event)"
                                [disableUpdate]="disableUpdate">
                    </mvs-widget>
                }
            </p-tabpanel>

            <p-tabpanel [value]="1">
                @if (activeTabIndex == 1 && allTicketCreate) {
                    <mvs-widget
                                [widgetData]="allTicketCreate"
                                (onObjectSelect)="handleTicketSelect($event)"
                                [disableUpdate]="disableUpdate">
                    </mvs-widget>
                }
            </p-tabpanel>

            <p-tabpanel [value]="2">
                @if (activeTabIndex == 2 && allTicketCloseCreate) {
                    <mvs-widget
                                [widgetData]="allTicketCloseCreate"
                                (onObjectSelect)="handleTicketSelect($event)"
                                [disableUpdate]="disableUpdate">
                    </mvs-widget>
                }
            </p-tabpanel>

<!--            <p-tabpanel [value]="3">-->
<!--                @if (activeTabIndex == 3 && assignedClosedTicketsWidget) {-->
<!--                    <mvs-widget-->
<!--                                [widgetData]="assignedClosedTicketsWidget"-->
<!--                                (onObjectSelect)="handleTicketSelect($event)"-->
<!--                                [disableUpdate]="disableUpdate">-->
<!--                    </mvs-widget>-->
<!--                }-->
<!--            </p-tabpanel>-->
        </p-tabpanels>
    </p-tabs>

}
